import React from "react";
import { useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, DisabledPrompt } from "bcms-react";
import Classes, { Account } from "model";
import { WidgetContainer, WidgetView } from "components/shared";
import { SecondaryButton, UICheckbox } from "components/ui";
import SearchOptionsFormView, { ScheduledSearchOptionsFormView } from "../SearchOptionsFormView";
import { ScheduledACHTableView } from "../BatchesACHTableView";
import ACHSearch from "../SearchOptionsFormView/classes/ACHSearch";

/**
 * @function ScheduledACHBatchesWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget used in ActivityACHPage.
 */
export default function ScheduledACHBatchesWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], val)
        .submit(setState);
      },

      onSearchChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch", prop ], val)
        .submit(setState);
      },

      onClear: () => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch" ], ACHSearch.init())
        .submit(setState);
      }
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <WidgetContent/>
    </StateManager>
  );
}

export const getDefaultData = () => ({
  //companyAccounts: CompanyAccount.initAll(), // may be used later
  //linkedAccounts: LinkedAccount.initAll(), // may be used later
  isScheduledACHSearch: true,
  showSearchOptions: false,
  achSearch: ACHSearch.init(),
  businessAccounts: Account.initAllBusiness()
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function WidgetContent(props) {
  const { data, onChange } = useStateManager();

  return (
    <WidgetContainer className="scheduled-ach-batches-widget">
      <WidgetView dataPoint="Scheduled_ACH_Batches_Label" text="Scheduled ACH Batches">
        <UICheckbox label="Show Search Options" value={ data.showSearchOptions ? "checked" : "" } 
        onChange={ onChange("showSearchOptions")} />
        { data.showSearchOptions && 
        <SearchOptionsFormView offsetAccounts={ data.businessAccounts } isScheduledACHSearch={ data.isScheduledACHSearch } />
        }
        {/*<ScheduledSearchOptionsFormView />*/}
        <ScheduledACHTableView data={ data } />
      </WidgetView>
      <div className="button-container flex-container flex-horizontal">
          <DisabledPrompt>
            <SecondaryButton className="export-button" text="Export" />
          </DisabledPrompt>
      </div>
    </WidgetContainer>
  );
}
